export default __webpack_public_path__ + "static/ActaHeadline-Book-e68b6312083a137337c3669c1095c190.woff2";